import { http } from '../../config/axios'

const findCampanha = (params: any): Promise<any> => {
  const { first, rows, page, descricao, ativo, sortField, sortOrder } = params ?? {};
  const pathParams = [first, rows, page, sortField, sortOrder]
    .map((v) => encodeURIComponent(v))
    .join('/');
  const queryParams: any = {};
  if (descricao) {
    queryParams.descricao = String(descricao).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  }
  if (ativo !== null && ativo !== undefined) {
    queryParams.ativo = ativo;
  }
  return http
    .get('api/campanha/find/' + pathParams, { params: queryParams })
    .then((res) => res.data as any)
    .catch((error) => {
      console.error('Erro findCampanha', error)
      throw Error(error.response.data)
    })
}

export default findCampanha;
